function getLastTextNode(element) {
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    let lastTextNode = null;

    while (walker.nextNode()) {
        if (walker.currentNode.textContent.trim()) {
            lastTextNode = walker.currentNode;
        }
    }

    return lastTextNode;
}

function wrapTrailingEllipsis(element) {
    if (!element || element.dataset.typingReady === 'true') {
        return null;
    }

    const lastTextNode = getLastTextNode(element);

    if (!lastTextNode) {
        return null;
    }

    const originalText = lastTextNode.textContent || '';
    const trimmedText = originalText.replace(/\s+$/, '');

    const ellipsisMatch = trimmedText.match(/(\.\.\.|…)$/u);

    if (!ellipsisMatch) {
        return null;
    }

    const trailingWhitespace = originalText.slice(trimmedText.length);
    const ellipsisText = ellipsisMatch[0];
    const textBeforeEllipsis = trimmedText.slice(0, -ellipsisText.length);
    const fragment = document.createDocumentFragment();

    if (textBeforeEllipsis) {
        fragment.append(document.createTextNode(textBeforeEllipsis));
    }

    const ellipsis = document.createElement('span');
    ellipsis.className = 'text-outline-white__typing';
    ellipsis.setAttribute('aria-label', ellipsisText);
    ellipsis.setAttribute('role', 'img');

    const typingCharacters = ellipsisText === '…' ? ['.', '.', '.'] : Array.from(ellipsisText);

    typingCharacters.forEach((character, index) => {
        const characterNode = document.createElement('span');
        characterNode.className = 'text-outline-white__typing-char';
        characterNode.textContent = character;
        characterNode.style.setProperty('--typing-step', `${index + 1}`);
        ellipsis.append(characterNode);
    });

    fragment.append(ellipsis);

    if (trailingWhitespace) {
        fragment.append(document.createTextNode(trailingWhitespace));
    }

    lastTextNode.parentNode.replaceChild(fragment, lastTextNode);
    element.dataset.typingReady = 'true';

    return ellipsis;
}

document.addEventListener('DOMContentLoaded', () => {
    const outlinedTexts = document.querySelectorAll('.text-outline-white');

    if (!outlinedTexts.length) {
        return;
    }

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const ellipsisNodes = Array.from(outlinedTexts)
        .map((element) => wrapTrailingEllipsis(element))
        .filter(Boolean);

    if (!ellipsisNodes.length) {
        return;
    }

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
        ellipsisNodes.forEach((ellipsis) => ellipsis.classList.add('is-active'));
        return;
    }

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) {
                return;
            }

            entry.target.classList.add('is-active');
            observer.unobserve(entry.target);
        });
    }, {
        threshold: 0.6,
    });

    ellipsisNodes.forEach((ellipsis) => observer.observe(ellipsis));
});